// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
    text-align: center;
}

.App-logo {
    height: 40vmin;
    pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #282c34;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
}

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.login-layout{
    width: 400px;
    margin: 0 auto;
    position: relative;

    /*display: table-cell;*/
    height: 100vh;
}

.login-container{
    position: absolute;
    top: 20%;
}



.login-form-container{
    background-color: white;
    /*padding: 90px;*/
    vertical-align: middle;
}

.support-link{
    /*position: absolute;*/
}

.slide-image{
    margin: 30px auto;
}

.login-forgot-password-link{
    width:33%;
    float: left;
}

.fs-14px{
    font-size: 12px;
}
  
.wrapper{
    position: absolute;
    top: 20%;
}

.account-info-row{
    display: block;
    padding: 10px;
    width: 100%;
}

.account-row-field{
    font-weight: bold;
    display: block;
}

.account-row-value{
    padding-left: 5px;
}


@media (max-width: 768px) {
    .container-detail {
        width: 50%;
        padding: 2%;
    }
    .container-header {
        display: flex;
        flex-wrap: wrap;
        flex: 50% 1; /* or - flex: 0 50% - or - flex-basis: 50% - */
        /*demo*/
    }
    p {
        font-size: 12px; /* Adjust the font size as needed for mobile view */
    }
    .codiLogo {
        display: none;
    }
    .text-base {
        font-size: 12px;
    }
    .text-black {
        font-size: 14px;
    }
    .cell-breakWord {
        word-wrap: break-word;
        max-width: 1px;
    }

    .wrapper{
        position: absolute;
        top: 10%;
    }
}

.error{

}

.error-message, .error.message, .error .message{
    background-color: lightcoral;
    color: red;
}

.forgot-email{
    width: 300px;
}

/*.mobile-view, */.nav-container nav{
                      position: absolute !important;
                      border: 1px solid #999;
                      width:100%;
                      z-index: 1000;
                  }

.mobile-view{
    height: 60px;
}
/*
.mobile-wrapper header{
    margin-bottom: 100px;
}*/

/*.mobile-wrapper{
    height: 200px !important;
}*/

.mobile-menu-wraper{
    height: 60px;
}

.keyword{
    width:33%;
}

.grid-container{
    background-color: #EEE;
}

.grid{
    /* border: solid 1px #EEE;
    background-color: #FFF; */
    margin: 6px;
    text-align: left !important;
    padding: 3px;
}

.grid>div{
    text-align: left !important;
}

.search-bar label{
    float: left;
    display: inline-block;
}

.new-user-btn{
    margin: 0 auto;
}

.new-user-btn-container{
    text-align: center;
}

.contact-form input, .contact-form select{
    border-radius: 40px;
    border: solid 1px #444;
}

/*.contact-form div div{
    width:50%;
    float: left;
}*/

.contact-form>div{
    padding: 20px;
}

.contact-form label{
    padding: 3px;
}

.customer-form input, .customer-form select{
    border-radius: 40px;
    border: solid 1px #444;
}

/*.contact-form div div{
    width:50%;
    float: left;
}*/

.customer-form>div{
    padding: 20px;
}

.customer-form label{
    padding: 3px;
}

.half-width{
    width: 50%;
    padding-left: 20px;
}

.left{
    float: left;
    padding-left: 0px;
    padding-right: 20px;
}

.left-half-width{
    width: 40%;
}

.customer-info-col{
    width: 100%;
}


/*.manage-users-container .search-options{
    display: none;
}*/`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;;IAElB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;;;AAIA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI;QACI,UAAU;QACV,WAAW;IACf;IACA;QACI,aAAa;QACb,eAAe;QACf,WAAS,EAAE,8CAA8C;QACzD,OAAO;IACX;IACA;QACI,eAAe,EAAE,mDAAmD;IACxE;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,QAAQ;IACZ;AACJ;;AAEA;;AAEA;;AAEA;IACI,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA,iBAAiB,CAAC;sBACI,6BAA6B;sBAC7B,sBAAsB;sBACtB,UAAU;sBACV,aAAa;kBACjB;;AAElB;IACI,YAAY;AAChB;AACA;;;EAGE;;AAEF;;EAEE;;AAEF;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;6BACyB;IACzB,WAAW;IACX,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;;EAGE;;AAEF;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;;;EAGE;;AAEF;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;;AAGA;;EAEE","sourcesContent":[".App {\n    text-align: center;\n}\n\n.App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #282c34;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.login-layout{\n    width: 400px;\n    margin: 0 auto;\n    position: relative;\n\n    /*display: table-cell;*/\n    height: 100vh;\n}\n\n.login-container{\n    position: absolute;\n    top: 20%;\n}\n\n\n\n.login-form-container{\n    background-color: white;\n    /*padding: 90px;*/\n    vertical-align: middle;\n}\n\n.support-link{\n    /*position: absolute;*/\n}\n\n.slide-image{\n    margin: 30px auto;\n}\n\n.login-forgot-password-link{\n    width:33%;\n    float: left;\n}\n\n.fs-14px{\n    font-size: 12px;\n}\n  \n.wrapper{\n    position: absolute;\n    top: 20%;\n}\n\n.account-info-row{\n    display: block;\n    padding: 10px;\n    width: 100%;\n}\n\n.account-row-field{\n    font-weight: bold;\n    display: block;\n}\n\n.account-row-value{\n    padding-left: 5px;\n}\n\n\n@media (max-width: 768px) {\n    .container-detail {\n        width: 50%;\n        padding: 2%;\n    }\n    .container-header {\n        display: flex;\n        flex-wrap: wrap;\n        flex: 50%; /* or - flex: 0 50% - or - flex-basis: 50% - */\n        /*demo*/\n    }\n    p {\n        font-size: 12px; /* Adjust the font size as needed for mobile view */\n    }\n    .codiLogo {\n        display: none;\n    }\n    .text-base {\n        font-size: 12px;\n    }\n    .text-black {\n        font-size: 14px;\n    }\n    .cell-breakWord {\n        word-wrap: break-word;\n        max-width: 1px;\n    }\n\n    .wrapper{\n        position: absolute;\n        top: 10%;\n    }\n}\n\n.error{\n\n}\n\n.error-message, .error.message, .error .message{\n    background-color: lightcoral;\n    color: red;\n}\n\n.forgot-email{\n    width: 300px;\n}\n\n/*.mobile-view, */.nav-container nav{\n                      position: absolute !important;\n                      border: 1px solid #999;\n                      width:100%;\n                      z-index: 1000;\n                  }\n\n.mobile-view{\n    height: 60px;\n}\n/*\n.mobile-wrapper header{\n    margin-bottom: 100px;\n}*/\n\n/*.mobile-wrapper{\n    height: 200px !important;\n}*/\n\n.mobile-menu-wraper{\n    height: 60px;\n}\n\n.keyword{\n    width:33%;\n}\n\n.grid-container{\n    background-color: #EEE;\n}\n\n.grid{\n    /* border: solid 1px #EEE;\n    background-color: #FFF; */\n    margin: 6px;\n    text-align: left !important;\n    padding: 3px;\n}\n\n.grid>div{\n    text-align: left !important;\n}\n\n.search-bar label{\n    float: left;\n    display: inline-block;\n}\n\n.new-user-btn{\n    margin: 0 auto;\n}\n\n.new-user-btn-container{\n    text-align: center;\n}\n\n.contact-form input, .contact-form select{\n    border-radius: 40px;\n    border: solid 1px #444;\n}\n\n/*.contact-form div div{\n    width:50%;\n    float: left;\n}*/\n\n.contact-form>div{\n    padding: 20px;\n}\n\n.contact-form label{\n    padding: 3px;\n}\n\n.customer-form input, .customer-form select{\n    border-radius: 40px;\n    border: solid 1px #444;\n}\n\n/*.contact-form div div{\n    width:50%;\n    float: left;\n}*/\n\n.customer-form>div{\n    padding: 20px;\n}\n\n.customer-form label{\n    padding: 3px;\n}\n\n.half-width{\n    width: 50%;\n    padding-left: 20px;\n}\n\n.left{\n    float: left;\n    padding-left: 0px;\n    padding-right: 20px;\n}\n\n.left-half-width{\n    width: 40%;\n}\n\n.customer-info-col{\n    width: 100%;\n}\n\n\n/*.manage-users-container .search-options{\n    display: none;\n}*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
